import React from 'react';

import ToggableActionButton from '../common/ToggableActionButton';
import ActionButton from '../common/ActionButton';

interface OutageNotificationActionsBarProps {
    onNew: () => void;
    onEdit: () => void;
    onRemove: () => void;
    filter: ([]) => void;
    clearFilter: () => void;
}

export default class OutageNotificationActionsBar extends React.Component<OutageNotificationActionsBarProps> {
    constructor(props: OutageNotificationActionsBarProps) {
        super(props);

        this.state = {
            filters: [],
        };
    }

    onShowActive = () => {
        const filters = [];
        filters[0] = {
            field: 'notificationTo',
            operator: 'gte',
            value: new Date().toISOString(),
        };

        this.props.filter(filters);
    };

    onShowAll = () => {
        this.props.clearFilter();
        this.setState({ filters: {} });
    };

    render() {
        return (
            <div className="actions">
                <ActionButton text="Add" onClick={this.props.onNew} icon="plus" />
                <ActionButton text="Edit" onClick={this.props.onEdit} icon="pencil" selection="one" />
                <ActionButton text="Remove" onClick={this.props.onRemove} icon="delete" selection="multi" />
                <ToggableActionButton text="ShowActive" onSelected={this.onShowActive} onNotSelected={this.onShowAll} icon="filter" />
            </div>
        );
    }
}
